import axiosInstance from "../axiosInstance";

export const accessLogService = {
  fetch: async (limit, skip, clientId, query) => {
    try {
      let api = `/access-log?$limit=${limit || 15}&$skip=${skip || 0}`;
      if (clientId) {
        api += `&client=${clientId}`;
      }
      if (query) {
        api += `&${query}`;
      }
      if (!api.includes("$sort")) {
        api += `&$sort[createdAt]=-1`;
      }
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  fetchUniqueValues: async (key, searchKey, limit = 15, skip = 0) => {
    try {
      let query = `limit=${limit}&skip=${skip}&key=${key}`;
      if (searchKey) {
        query += `&searchkey=${encodeURIComponent(searchKey)}`;
      }
      const response = await axiosInstance.get(
        `/fetch-access-log-unique-fields?${query}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  exportAccessLog: async (clientId, query) => {
    try {
      let api = `/export-access-log?`;
      if (clientId) {
        api += `&client=${clientId}`;
      }
      if (query) {
        api += `&${query}`;
      }
      const response = await axiosInstance.get(api);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
